export default __webpack_public_path__ + "static/media/house-cook.24c78e46.svg";